import PropTypes from "prop-types"

const CustomFieldTextField = ({
  index,
  defaultValue,
  onDefaultValueChange,
  disabled,
}) => {
  const baseId = `custom-field-${index}-text`
  return (
    <div className="field">
      <div className="label">
        <label htmlFor={`${baseId}-default`}>Default value</label>
      </div>
      <div className="input">
        <input
          id={`${baseId}-default`}
          type="text"
          name="defaultValue"
          value={defaultValue || ""}
          onChange={e => onDefaultValueChange(e.target.value)}
          disabled={disabled}
          required
        />
      </div>
    </div>
  )
}

CustomFieldTextField.propTypes = {
  index: PropTypes.number.isRequired,
  defaultValue: PropTypes.string,
  onDefaultValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default CustomFieldTextField
